module.exports = __webpack_public_path__ + "img/logo-mo-28.e33f4567.svg";